module.exports = __webpack_public_path__ + "media/images/icon_faq_1-c9331dff7120138a882e6296f4c4dc75.png";